import {Component} from 'preact';

const AMIO_CHAT_URL = 'https://chat-widget.amio.io/static/amio-webchat-loader.min.js';

function initAmio() {
    const script = document.createElement('script');

    script.src = AMIO_CHAT_URL;

    script.onload = () => {
        window.amioWebchat.init({
            channelId: '6961212722864996793',
            logoUrl: 'https://amio-assets.s3.eu-central-1.amazonaws.com/footshop_logo.png',
            theme: 'footshop',
            lang: 'en-footshop',
            startOpened: false,
            zIndex: '2000',
            hideLauncher: 'never',
            hideCloseButton: false,
            wideButton: true,
        });
    };

    return script;
}

class ChatWithUs extends Component {
    componentDidMount() {
        const script = initAmio();

        script.type = 'text/javascript';
        script.charset = 'utf-8';
        script.async = true;

        document.getElementsByTagName('head')[0].appendChild(script);
    }

    render() {
        return null;
    }
}

export default ChatWithUs;


// WEBPACK FOOTER //
// ./components/chat-with-us/ChatWithUs/index.jsx